// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1279":"79a4d110","1366":"79a4d110","4959":"79a4d110","8394":"79a4d110","9001":"79a4d110"}[chunkId] + ".chunk.css";
};